module.exports = __webpack_public_path__ + "img/paved.9f229b34.png";